import Dashboard from '@/pages/dashboard/Dashboard'
import Denied from '@/pages/dashboard/Denied'
import Home from '@/pages/dashboard/Home'

const DashboardRoutes = [
    {path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: {permission: 'dashboard'}},
    {path: '/', name: 'Home', component: Home},
    {path: '/access-denied', name: 'Denied', component: Denied}
];

export default DashboardRoutes;